




























import {Component, Prop, Vue} from "vue-property-decorator";
import CompanyService from "@/services/CompanyService";
import {namespace} from "vuex-class";

const AppModule = namespace("App");

@Component
export default class SubmissionIdModal extends Vue {
    @Prop({required: true})
    private id!: number;

    @Prop({required: true})
    private onSave!: () => void;

    private submissionId = "";
    private message = "";
    private successful = false;

    @AppModule.Action
    private startLoading!: () => void;

    @AppModule.Action
    private stopLoading!: () => void;

    private save() {
        this.startLoading();
        this.message = "";
        CompanyService.updateBusinessTaxReturnSubmissionId(this.id, this.submissionId).then(
            () => {
                this.successful = true;
                this.message = "Submission ID successfully updated!";
                this.onSave();
                this.stopLoading();
                setTimeout(() => this.closeModal(), 1000);
            },
            err => {
                this.successful = false;
                this.message = "Error updating Submission ID";
                this.stopLoading();
            }
        );
    }

    private closeModal() {
        this.$modal.hideAll();
    }
}
